import { ArticleHeading5, ArticleParagraph2 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from '../../containers/MasterTabsContainer/MaterTabs.css';
import { EMasterTabs } from '../../types/masterFilters';

type TMasterTabProps = {
  title: string;
  value: EMasterTabs;
  unreadMessagesCount: number;
  isSelected: boolean;
  handleClick: (value: EMasterTabs) => void;
};

export const MasterTab: React.FC<TMasterTabProps> = ({
  title,
  value,
  unreadMessagesCount,
  isSelected,
  handleClick,
}) => {
  return (
    <div className={classNames(styles['tab'], isSelected && styles['tab_selected'])} onClick={() => handleClick(value)}>
      <ArticleHeading5 color={isSelected ? 'text-main-default' : 'text-primary-default'}>{title}</ArticleHeading5>
      {unreadMessagesCount > 0 ? <ArticleParagraph2 color="gray60_100">{unreadMessagesCount}</ArticleParagraph2> : null}
    </div>
  );
};
